// extracted by mini-css-extract-plugin
export var calendar = "DateForm-module--calendar--1f665";
export var calendarWrapper = "DateForm-module--calendarWrapper--3e808";
export var darkText = "DateForm-module--dark-text--f96d9";
export var dates = "DateForm-module--dates--41277";
export var daysOfTheWeek = "DateForm-module--days-of-the-week--0115d";
export var digitalWalkIn = "DateForm-module--digital-walk-in--6aaee";
export var fullyBookedOrClosed = "DateForm-module--fully-booked-or-closed--253e7";
export var grid = "DateForm-module--grid--e9b4d";
export var hasSelectedSlot = "DateForm-module--has-selected-slot--30e6c";
export var icon = "DateForm-module--icon--bf946";
export var isPast = "DateForm-module--isPast--ce393";
export var isSelected = "DateForm-module--is-selected--c072b";
export var isToday = "DateForm-module--is-today--d9fb5";
export var label = "DateForm-module--label--f1325";
export var loading = "DateForm-module--loading--4dcfc";
export var nearbyLocations = "DateForm-module--nearby-locations--2f0e2";
export var nearbyLocationsTitle = "DateForm-module--nearby-locations-title--2bcb2";
export var nearbySlotButton = "DateForm-module--nearby-slot-button--17cfa";
export var next = "DateForm-module--next--5063b";
export var nextWeekDays = "DateForm-module--next-week-days--e6c52";
export var nextYear = "DateForm-module--nextYear--5403e";
export var noAvailability = "DateForm-module--no-availability--be520";
export var noAvailabilityHeader = "DateForm-module--no-availability-header--e3f10";
export var noAvailabilityText = "DateForm-module--no-availability-text--82a12";
export var noAvailabilityTitle = "DateForm-module--noAvailabilityTitle--38861";
export var placeholder = "DateForm-module--placeholder--c758e";
export var previous = "DateForm-module--previous--5abd4";
export var previousWeekDays = "DateForm-module--previous-week-days--beb67";
export var previousYear = "DateForm-module--previousYear--8f3ca";
export var promo = "DateForm-module--promo--ab17d";
export var providers = "DateForm-module--providers--c8395";
export var providersButtons = "DateForm-module--providers-buttons--f01f5";
export var providersSelect = "DateForm-module--providers-select--fe40a";
export var root = "DateForm-module--root--25813";
export var sameDayNote = "DateForm-module--same-day-note--6b6a9";
export var selectItem = "DateForm-module--select-item--4d4d1";
export var selectMenu = "DateForm-module--select-menu--3ffda";
export var selectMenuPaper = "DateForm-module--select-menu-paper--5f2c1";
export var selectedItem = "DateForm-module--selected-item--36f3d";
export var slots = "DateForm-module--slots--9f1fb";
export var slotsButtons = "DateForm-module--slots-buttons--fc8d6";
export var slotsCard = "DateForm-module--slots-card--a7b45";
export var slotsHeader = "DateForm-module--slots-header--99194";
export var slotsWrapper = "DateForm-module--slots-wrapper--7c0c7";
export var submit = "DateForm-module--submit--597d1";
export var swipeUpCard = "DateForm-module--swipe-up-card--b46a8";
export var thisWeekDays = "DateForm-module--this-week-days--4d8dd";
export var todaySameDayAvailability = "DateForm-module--todaySameDayAvailability--b2632";
export var weekDays = "DateForm-module--week-days--99064";